import { render, staticRenderFns } from "./assistantdetail.vue?vue&type=template&id=31b7a5a0&scoped=true"
import script from "./assistantdetail.vue?vue&type=script&lang=js"
export * from "./assistantdetail.vue?vue&type=script&lang=js"
import style0 from "./assistantdetail.vue?vue&type=style&index=0&id=31b7a5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7a5a0",
  null
  
)

export default component.exports